export interface IToastOption {
  duration: number;
  type: ToastActionType;
}
export interface IToast {
  id?: string;
  message: any;
  options: IToastOption;
}
export enum ToastActionType {
  SUCCESS = 'SUCCESS',
  WARN = 'WARN',
  ERROR = 'ERROR',
  INFO = 'INFO',
}
